import React, { Component } from 'react'
import { Modal, ModalTitle } from 'react-bootstrap'
import Button from '../../components/UI/Buttons/Button'
import Buttons from '../../components/UI/Buttons'
import IncidentInjuryDetails from './IncidentInjuryDetails';
import RestrictionsReferrals from './RestrictionsReferrals';
import Billing from './Billing';
import IncidentVisitsTab from './IncidentVisitsTab';
import WithRoutify from '../../hoc/WithRoutify';
import withReduxState from '../../hoc/wReduxState';
import IncidentService from '../../services/IncidentService';
import { CREATED, OK } from '../../utils/constant';
import Icd10Service from '../../services/Icd10Service';
import { convertUnderScoreStrings, isSet, toQueryString } from '../../utils/commonUtils';
import ProviderService from '../../services/ProviderService';
import EmrVisitsService from '../../services/EmrVisitsService';
import Alert from '../../components/UI/ConfirmBox/Alert';
import InsuranceService from '../../services/InsuranceService';
import DropDownService from '../../services/DropDownService';
import CompanyService from '../../services/CompanyService';
const BASE_TABS = [
    { label: "Incident / Injury Details", component: IncidentInjuryDetails },
    { label: "Restrictions & Referrals", component: RestrictionsReferrals },
    { label: "Billing", component: Billing }
];

// Visit categories that should hide Restrictions & Referrals tab
const SIMPLIFIED_INCIDENT_CATEGORIES = [
    'Urgent Care - Injury',
    'Urgent Care - Illness',
    'Urgent Care - Follow Up',
    'Urgent Care - Cash Patient',
    'Urgent Care - Telehealth',
    'Private - Mental Health Exam',
    'Private - Primary Care - Initial',
    'Private - Primary Care - Follow Up'
];

const VISITS_TAB = { label: "Visits", component: IncidentVisitsTab };

 class AddIncidentModal extends Component {
    constructor(props) {
        super(props);
        // Initialize state 
        this.state = {
            activeTab:0,
            showAlert:false,
            formData:{
              relatedness:"",
              incident_type:"Injury",
            },
            LookupList:{},
            icd10List:[],
            validations:{},
            providerOptions:[],
            workCompInsuranceList:[],
            companyList:[]
        }
    }
    componentDidMount(){
      
      if(this.props.isEdit){
          this.getIncidentById()
      }else{
        this.fetchProviderOptions(this.props.employeeDetails)  
      }
      this.fetchLookUp()
      this.fetchIcd10List()      
      this.fetchWorkCompInsurance()
      this.fetchCompanyList()           
      if(isSet(this.props.savedVisit,'')!==''){
        this.setState({
          ...this.state,
          formData:{...this.state.formData,
            employee_id:this.props.savedVisit.employee_id||"",
            employer_id:this.props.savedVisit.company.company_uuid||"",
            employer_phone:this.props.savedVisit.company.phone||"",
            work_comp_insurance_tpa: this.props.savedVisit.company.work_comp_insurance || "",
            policy_number: this.props.savedVisit.company.work_comp_policy_number || "",
            work_comp_injury: this.props.savedVisit.company.work_comp_insurance || "",
          }
        })
      }
      
    }
    fetchCompanyList=async()=>{
      try{
        let companyListResponse = await DropDownService.getCompanies(null);
        let companyListOptions = [{ label: "-Select Company", value: "" }];
        companyListResponse &&
          companyListResponse?.forEach((company, companyInd) => {
            companyListOptions.push({
              label: company.name,
              value: company.company_uuid,
            });
          });
        this.setState({ companyList: companyListOptions });
      }catch(err){

      }
    }
    fetchProviderOptions=async(employeeDetails)=>{
    let optionArr = [];
    try{
        const data = await ProviderService.getProviderByClinicId(employeeDetails.clinic_id,{search:""});
        isSet(data,[]).map((item,itemIndex)=>{
            optionArr.push({
                label:isSet(item.first_name,'')+' '+isSet(item.last_name,''),
                value:item.provider_id,
                data:item,
                index:itemIndex
            })
        });
        
        this.setState({providerOptions:optionArr})
    }catch(e){

    }
    }
    fetchIcd10List=async(term, callback = () => {})=>{
      try{
        const queryString = toQueryString({
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "code",
          sort_order: "asc",
          search: {
            search_query:term
          },
        });
         this.props.Loader(true);
         const response = await Icd10Service.getIcdList(queryString);
         console.log("res",response);
         if(response && response?.data.data){
            const options=response?.data.data.map((val)=>({
              label:`${val.code} - ${convertUnderScoreStrings(val.description)}`,
              value:val.icd10_id
            }))
       
            this.setState({icd10List:options})
            callback(options)
         }
         
      }catch(err){

      }finally{
          this.props.Loader(false)
      }
    }
    getIncidentById=async()=>{
      try{
         this.props.Loader(true);
         const response = await IncidentService.getIncidentById(this.props.visitId);
        
        if (response == null) {
          const employerName = this.props.employeeDetails.company.company_uuid
          const employeernumber = this.props.employeeDetails.company.phone
          console.log("saved",this.props.employeeDetails);
          
          const res = {
            ...this.state.formData,
            employer_id: employerName,
            employer_phone: employeernumber,
            employee_id: this.props.employeeDetails.employee_id,
            work_comp_insurance_tpa: this.props.employeeDetails.company.work_comp_insurance || "",
            policy_number: this.props.employeeDetails.company.work_comp_policy_number || "",
            work_comp_injury:this.props.employeeDetails.company.work_comp_insurance || ""
          }
          this.setState({ formData: res })
          this.fetchProviderOptions(response.employee_details)
        }
         if(response.incident_id && response.incident_id!==''){
          this.setState({formData:response})  
          this.fetchProviderOptions(response.employee_details)  
         } 
     
      }catch(err){

      }finally{
         this.props.Loader(false);
      }
    }
    fetchLookUp=async()=>{
      const lookupKeys=["body_zone","nature_of_incident","recordable_or_first_aid","work_restrictions","policy_expiration","work_restriction_weight_bearing","work_restriction_lifting_carrying","work_restriction_sitting_standing","work_restriction_standing_duration","work_restriction_walking_distance","work_restriction_pushing_pulling","work_restriction_breaks","work_restriction_max_shift_length","work_restriction_equipment_use","work_restriction_overhead_reaching","work_restriction_repetitive_grasping","work_restriction_climbing_stairs_ladders","work_restriction_squatting_kneeling","work_restriction_bending_back","work_restriction_spine","work_restriction_dme_use","work_restriction_environmental_exposures"]
      try{
         this.props.Loader(true);
        const results = await Promise.all(
          lookupKeys.map((key) => {
            // const payload = { key };
            return IncidentService.getLookUpList(key);
          })
        );
        
        const lookupData = {};
        lookupKeys.forEach((key, index) => {
          lookupData[key] = results[index].map((item) => ({
            label: item.value,
            value: item.value
          }));
        });        
        this.setState({LookupList:lookupData})        

      }catch(err){
         this.props.Toast.error("Something went wrong!")
      }finally{
         this.props.Loader(false);
      }
    }
    fetchWorkCompInsurance = async () => {
    try {
        const options = await InsuranceService.getWorkCompInsuranceList();
        const defaultOption = { label: "-Select-", value: "" };        
        const optionsWithDefault = [defaultOption, ...options];
        this.setState({ workCompInsuranceList: optionsWithDefault });
    } 
    catch(error){
        console.error("Error loading Work Comp Insurance", error);
    }
};
    tabHandler=(activeTab,isvalidate=false)=>{
     if(isvalidate){
      this.formSaveHandler(activeTab)
     }else{
        this.setState({activeTab:activeTab})
     }
    }

    formSaveHandler=async(activeTab)=>{

      // Process payload - remove referral fields when checkbox is unchecked
      let processedFormData = { ...this.state.formData };
      if (
        processedFormData.discharge_date === "Invalid Date" ||
        processedFormData.discharge_date === "" ||
        processedFormData.discharge_date === undefined
      ) {
        processedFormData.discharge_date = null;
      }
      
      // List of referral checkbox fields
      const referralFields = [
        'acupuncture', 'cardiology', 'chiropractic', 'dermatology',
        'ent_ear_nose_throat', 'general_surgery', 'hand_surgery',
        'multi_specialties_organization', 'neurology', 'ophthalmology_optometry',
        'orthopedics', 'pain_management', 'physical_therapy', 'plastic_surgery',
        'primary_care_physician_pcp', 'psychology_psychiatry', 'pulmonology', 'urology'
      ];
      
      // Remove referral fields when checkbox is unchecked
      referralFields.forEach(fieldName => {
        const checkboxValue = processedFormData[fieldName];
        const referralFieldName = `${fieldName}_referral`;
        
        // If checkbox is unchecked (0, "0", false, null, undefined), remove referral field
        if (!checkboxValue || checkboxValue == 0 || checkboxValue === "0" || checkboxValue === false) {
          processedFormData[fieldName] = "0"; // Ensure it's "0" for consistency
          delete processedFormData[referralFieldName]; // Remove referral field from payload
        } else {
          // If checked, ensure referral field exists or set to null
          if (!processedFormData[referralFieldName]) {
            processedFormData[referralFieldName] = null;
          }
        }
      });

      // For simplified categories, skip date_reported validation requirement
      const isSimplifiedCategory = SIMPLIFIED_INCIDENT_CATEGORIES.includes(this.props.visitCategory);
      // Check if user has employer_admin role (should hide Restrictions & Referrals tab)
      const isEmployerAdmin = this.props.profile?.role === 'employer_admin';
      const WorkCompNewInjury = this.props.visitCategory === 'Work Comp - New Injury';
      const isEmployerView = isEmployerAdmin && WorkCompNewInjury;
      
      // For simplified categories: Tab 0 = Incident Details, Tab 1 = Billing (last tab)
      // For regular categories: Tab 0 = Incident Details, Tab 1 = Restrictions, Tab 2 = Billing (last tab)
      // Backend expects "tab2" to save, so for simplified categories on Tab 1, send "tab2"
      let validationTab = "tab" + this.state.activeTab;
      if ((isSimplifiedCategory || isEmployerView) && this.state.activeTab === 1) {
        validationTab = "tab2"; // Send tab2 to trigger save in backend
      }
      
      const payload = { 
        ...processedFormData,
        current_validation: validationTab, 
        visit_id: this.props.visitId,
        type:'incident',
        skip_date_reported_validation: isSimplifiedCategory, // Flag to skip backend validation (only for simplified categories, not Work Comp - New Injury)
      }

      try {
      this.props.Loader(true);
      let data={}
      if(payload.incident_id && this.props.isEdit===true){
          data = await IncidentService.updateIncidentById(payload.incident_id,payload);
        
      }else{
          data = await IncidentService.saveIncident(payload);
      }
      console.log("data",data);
      
      if (data.status && data.status === "ERROR") {
        // if (isObject(data.data)) {
        //   for (let key in data.data) {
        //     updateValidation = {
        //       ...updateValidation,
        //       [key]: data.data[key].join(","),
        //     };
        //   }
        // } else {
        //   props.Toast.error(data.data);
        // }
        // if (Object.keys(updateValidation).length > 0) {
          this.setState({validations:data.data});
        //     FieldValidationFocus(inputFields, updateValidation);         
        // }
      }else if(data.code===CREATED || data.code===OK){
        console.log("Code",data.code,this.state.activeTab);
        // For simplified categories, Tab 1 is the last tab (Billing), so save on Tab 1
        // For regular categories, Tab 2 is the last tab (Billing), so save on Tab 2
        const isSimplifiedCategory = SIMPLIFIED_INCIDENT_CATEGORIES.includes(this.props.visitCategory);
        const isEmployerAdmin = this.props.profile?.role === 'employer_admin';
        const isLastTab = (isSimplifiedCategory || isEmployerView) ? (this.state.activeTab === 1) : (this.state.activeTab === 2);
        
        if(isLastTab){
         await EmrVisitsService.SaveWorkRestriction(this.props.visitId, payload)
         await EmrVisitsService.saveAssessment(null,this.props.visitId,null, { ...payload, from_incident: true });
          this.props.Toast.success("Incident added successfully")
          // Reload incident data to get synced referrals from EMR
          if(this.props.visitId){
            await this.getIncidentById();
          }
          this.setState({activeTab:0,
            formData:{
              relatedness:"Undetermined",
              incident_type:"Injury",
            },icd10List:[],
            validations:{},
            providerOptions:[],
            LookupList:{}})
            this.props.incidentToogleHandler(false)
        }else{
        this.setState({activeTab})
        }
      }else if(data){
        console.log("Code",data.code);
        this.props.Toast.success("Incident added successfully")
          this.setState({activeTab:0,
            formData:{
              relatedness:"Undetermined",
              incident_type:"Injury",
            },icd10List:[],
            validations:{},
            providerOptions:[],
            LookupList:{}})
            this.props.incidentToogleHandler(false)
      }
    }catch(err){
      this.props.Toast.error("Something went wrong!")

    } finally{
         this.props.Loader(false);
    }}
    setActiveTabHandler=()=>{

    }

  resetAndCloseModal = () => {
    this.setState({
      activeTab: 0,
      LookupList: {},
      formData: {
        relatedness: "Undetermined",
        incident_type: "Injury",
      },
      icd10List: [],
      validations: {},
      providerOptions: [],
    });
    this.props.incidentToogleHandler(false);
  };
 //triggers when user tries to close the modal 
  handleModalCloseAttempt = () => {
    this.setState({ showAlert: true });
  };

  
  handleAlertClose = () => {
    this.setState({ showAlert: false });
  };

  handleAlertConfirm = () => {
    this.setState({ showAlert: false }, () => {
      this.resetAndCloseModal();
    });
  };

  handleSaveAndClose = async () => {
    this.setState({ showAlert: false }, async () => {
      await this.formSaveHandler(2);
    });
  };
  getCompanyDetails=async(id)=>{
    try{
      const res= await CompanyService.getCompany(null,id);
      if(res){        
        const val = {
          ...this.state.formData,
          employer_phone:res.phone,
          work_comp_insurance_tpa: res.work_comp_insurance,
          policy_number: res.work_comp_policy_number,
          work_comp_injury: res.work_comp_insurance
        }
        this.setState({formData:val})
      }
    }catch(err){

    }
  }
  onChangeHandler = (fieldName, value,e,label) => {    
    // Check if incident has a valid declined_date before allowing changes
    if(fieldName === 'employer_id' && isSet(value, '') !== '' ) { this.getCompanyDetails(value)}
    if(fieldName === "declined_date" && isSet(value, '') !== '' && value !== null && value !== undefined){
      // Check if it's a valid date format
      const dateObj = new Date(value);
      if(!isNaN(dateObj.getTime())){
        this.props.Toast.warning("This incident has been declined");
      }
    }

    let updatedFormData = { ...this.state.formData }
    let validation={...this.state.validations}
    
    // Generic handler for referral checkboxes - clear corresponding referral field when checkbox is unchecked
    // Handle both numeric 0 and string "0"
    const isUnchecked = (value === 0 || value === "0" || value === false || value === null || value === undefined);
    if(isUnchecked && !fieldName.endsWith('_referral')){
      const referralFieldName = `${fieldName}_referral`;
      if(updatedFormData.hasOwnProperty(referralFieldName) || this.state.formData.hasOwnProperty(referralFieldName)){
        updatedFormData[referralFieldName] = "";
        validation[referralFieldName] = "";
        // Also ensure checkbox value is "0" for consistency
        updatedFormData[fieldName] = "0";
      }
    }
    if (fieldName.startsWith("diagnosis_")) {
    Object.keys(updatedFormData).forEach((key) => {
      if (key.startsWith("diagnosis_") && key !== fieldName) {
        if (updatedFormData[key] === value) {
          // Remove from old field
          updatedFormData[key] = "";
          updatedFormData[`${key}_label`] =''
        }
      }
    });
    updatedFormData[`${fieldName}_label`]=label
  }
    updatedFormData[fieldName] = value;
    validation[fieldName]=""
    this.setState({
      formData: updatedFormData,
      validations:validation,
    });
  }
  tabtoogleHandler=(ind)=>{
    console.log("this.state.activeTab",this.state.activeTab,ind);
    
    // If navigating to Visits tab (index 3), just switch without saving
    if(ind === 3){
      this.setState({activeTab:ind})
      return;
    }
    
    if(ind>this.state.activeTab){
      this.formSaveHandler(ind)
    }else{
      this.setState({activeTab:ind})
    }

  }
  //handle error focus function
  handleErrorFocus = (sections, fieldRefs) => {
        const { validations } = this.state;
        let firstErrorFieldName = null;
        let errorSectionIndex = -1;
        // Loop through configuration passed from child
        for (let i = 0; i < sections.length; i++) {
            const sectionData = sections[i].data;
            const foundField = sectionData.find(item => isSet(validations[item.name], '') !== '');

            if (foundField) {
                firstErrorFieldName = foundField.name;
                errorSectionIndex = i;
                break;
            }
        }
        if (firstErrorFieldName && errorSectionIndex !== -1) {
            // Handle Accordion Logic
            const collapseId = `collapseCardExample_${errorSectionIndex}`;
            const collapseElement = document.getElementById(collapseId);
            const accordionHeaderLink = document.querySelector(`a[href="#${collapseId}"]`);
            
            if (collapseElement && !collapseElement.classList.contains('show')) {
                if (accordionHeaderLink) {
                    accordionHeaderLink.click();
                }
            }
            // Handle Scroll and Focus Logic
            setTimeout(() => {
                const elementWrapper = fieldRefs[firstErrorFieldName];
                if (elementWrapper) {
                    elementWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    const inputInside = elementWrapper.querySelector('input, select, textarea');
                    if (inputInside) {
                        inputInside.focus();
                    }
                }
            }, 300);
        }
    }
  render() {
    const {validations,providerOptions,icd10List,LookupList,formData,activeTab,workCompInsuranceList,companyList}=this.state
    const {isOpen,incidentToogleHandler,isFromIncidentList,visitCategory,profile}=this.props
    
    // Check if this is a simplified incident category
    const isSimplifiedCategory = SIMPLIFIED_INCIDENT_CATEGORIES.includes(visitCategory);
    // Check if user has employer_admin role (should hide Restrictions & Referrals tab)
    const isEmployerAdmin = profile?.role === 'employer_admin';
    const WorkCompNewInjury = visitCategory === 'Work Comp - New Injury';
    const isEmployerView = isEmployerAdmin && WorkCompNewInjury;
    // Filter tabs based on visit category and user role
    let filteredTabs = BASE_TABS;
    if (isSimplifiedCategory || isEmployerView) {
      // Remove Restrictions & Referrals tab for simplified categories, Work Comp - New Injury, and employer_admin role
      filteredTabs = BASE_TABS.filter(tab => tab.label !== "Restrictions & Referrals");
    }
    
    // Show Visits tab only when viewing from incident list page (/incident route)
    const showVisitsTab = isFromIncidentList && isSet(formData.incident_id, '') !== '';
    const MAIN_TABS = showVisitsTab ? [...filteredTabs, VISITS_TAB] : filteredTabs;
    
    return (
      <Modal
        show={isOpen}
        size='xl'
        dialogClassName='hResponsive'
        contentClassName='h-100'
        backdrop="static"
        keyboard={false}
        onHide={this.handleModalCloseAttempt}
      >
        <div className="sh_modalBox">
           
        <Modal.Header closeButton className="pb-0 border-0">
             <div className="text-lg  px-2 font-weight-bold">{isSet(formData.incident_id,"")!==""?"Update Incident":"Add Incident"}</div>
                            </Modal.Header>
                            <div className='modal-header pt-0'>
                             <div className="tabs-wrapper ">
                                    <ul className="nav nav-borders nav-tabs border-0" role="tablist">
                                        {MAIN_TABS.map((item, index) => (
                                            <li key={index}>
                                                <a
                                                    href="#!"
                                                    onClick={() => this.tabtoogleHandler(index)}
                                                    className={` nav-link ${index === activeTab ? "active" : ""}`}
                                                >
                                                    {item.label}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                </div>  
          <Modal.Body className="pt-2">
           <div className="card-body tab-content p-0">
                            {MAIN_TABS.map((item, index) => {
                                const TabComponent = item.component;
                                return (
                                    <div key={index} className={`tab-pane ${index === activeTab ? "show active" : ""}`}>
                                        <TabComponent
                                            {...this.props}
                                            formData={formData}
                                            onChangeHandler={this.onChangeHandler}
                                            LookupList={LookupList}
                                            providerOptions={providerOptions}
                                            icd10List={icd10List}
                                            fetchIcd10List={this.fetchIcd10List}
                                            validations={validations}
                                            selectedBodyPart={this.props.selectedBodyPart}
                                            setSelectedBodyPart={this.props.setSelectedBodyPart}
                                            workCompInsuranceList={workCompInsuranceList}
                                            handleErrorFocus={this.handleErrorFocus}
                                            companyList={companyList}
                                            visitCategory={visitCategory}
                                            isSimplifiedCategory={isSimplifiedCategory}
                                            isEmployerView={isEmployerView}
                                        />
                                    </div>
                                );
                            })}
                        </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            {
              activeTab === 0 ? (
                <Buttons
                  type='Single'
                  className="btn btn-primary"
                  clickHandler={() => this.tabHandler(1, true)}
                  label='Next'
                  acl={'any'}
                />
              ) : activeTab === 1 && !isSimplifiedCategory && !isEmployerView ? (
                <>
                  <Buttons
                    type='Single'
                    className="btn btn-primary"
                    clickHandler={() => this.tabHandler(0)}
                    label='Previous'
                    acl={'any'}
                  />
                  <Buttons
                    type='Single'
                    className="btn btn-primary"
                    clickHandler={() => this.tabHandler(2, true)}
                    label='Next'
                    acl={'any'}
                  />
                </>
              ) : activeTab === 1 && (isSimplifiedCategory || isEmployerView) ? (
                <>
                  <Buttons
                    type='Single'
                    className="btn btn-primary"
                    clickHandler={() => this.tabHandler(0)}
                    label='Previous'
                    acl={'any'}
                  />
                  <Buttons
                    type='Single'
                    className="btn btn-primary"
                    clickHandler={() => this.formSaveHandler(1)}
                    label='Save'
                    acl={'any'}
                  />
                </>
              ) : activeTab === 2 ? (
                <>
                  <Buttons
                    type='Single'
                    className="btn btn-primary"
                    clickHandler={() => this.tabHandler(1)}
                    label='Previous'
                    acl={'any'}
                  />
                  <Buttons
                    type='Single'
                    className="btn btn-primary"
                    clickHandler={() => this.formSaveHandler(2)}
                    label='Save'
                    acl={'any'}
                  />
                </>
              ) : activeTab === 3 && showVisitsTab && (
                <Buttons
                  type='Single'
                  className="btn btn-primary"
                  clickHandler={() => this.tabHandler(2)}
                  label='Previous'
                  acl={'any'}
                />
              )
            }
          </Modal.Footer>
        </div>
        {this.state.showAlert && (
          <Alert
             contentTitle="You have unsaved changes.
            Would you like to save before exiting?." 
            content="Are you sure you want to cancel? This action will not save any of the changes made."
            onClose={this.handleAlertClose}
            onDelete={this.handleAlertConfirm}
            onSaveAndClose={this.handleSaveAndClose}
            type="warning"
            yesButtonName="Confirm"
            noButtonName="Cancel"
            saveAndClose={true} 
          />
        )}
      </Modal>
      
    )
  }

}
export default WithRoutify(withReduxState(AddIncidentModal));
